import { TaasVhvData } from '@ps20/bff-models';
import { GisDatenVHV } from '@ps20-frontend/frontend-models';
import { isNumber } from '@allianz/ng-aquila/utils';

export function setGisDataToVhvData(
  taasVhvData: TaasVhvData,
  gisDataFromState: GisDatenVHV,
): TaasVhvData {
  if (gisDataFromState) {
    taasVhvData.gisDaten = {
      bachzone: gisDataFromState.bachzone,
      zuersGefaehrdungsklasse: gisDataFromState.zuersGefaehrdungsklasse,
      konvergenz150: setNumber(gisDataFromState.konvergenz150),
      bewaldungsart20: setNumber(gisDataFromState.bewaldungsart20),
      bewaldungsart100: setNumber(gisDataFromState.bewaldungsart20),
      bewaldungsdichte: setNumber(gisDataFromState.bewaldungsdichte),
      bodenversiegelung: setNumber(gisDataFromState.bodenversiegelung),
      flutzone: setNumber(gisDataFromState.flutzone),
      gebaeudeGrundflaeche: setNumber(gisDataFromState.gebaeudeGrundflaeche),
      hoehe: setNumber(gisDataFromState.hoehe),
      konvergenz300: setNumber(gisDataFromState.konvergenz300),
      landform: setNumber(gisDataFromState.landform),
      senke: setNumber(gisDataFromState.senke),
      starkregenzone: setNumber(gisDataFromState.starkregenzone),
      steigung: setNumber(gisDataFromState.steigung),
      latitude: gisDataFromState.latitude,
      longitude: gisDataFromState.longitude,
      matchcode: gisDataFromState.matchcode,
      gleitenderNeuwert: null,
    };
  }

  return taasVhvData;
}

export function setNumber(arg: number): number {
  return isNumber(arg) ? arg : null;
}
